import { Field, useField, useForm } from 'react-final-form';
import { alignmentType, ApplicationContextType, GstAnalysisStatus, UnderwritingFormStatus, UnderwritingSteps, validationErrorTypes } from '../../../../interfaces/interfaces';
import styles from './GstAccount.module.scss'
import OutlinedFormInput from '../../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import TableUploadRow from '../../components/TableForm/TableUploadRow';
import { TableForm } from '../../components/TableForm/TableForm';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import { RestS } from '../../../../rest/rest-service';
import { useContext, useEffect, useMemo, useState } from 'react';
import GstOtpModal from './GstOtpModal';
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri'
import ConfirmDialog from '../../../../components/common/ConfirmDialog';
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { RiCheckboxCircleFill as CheckboxIcon } from 'react-icons/ri'
import { gstNumberValidation } from '../../../../components/functions/formValidation';
import { processingStatus } from '../../UploadDocuments/BankStatements';
import { getIn } from 'final-form';
import CircularLoader from '../../../../components/common/CircularLoader/CircularLoader';
import { RiErrorWarningFill as ErrorIcon } from 'react-icons/ri';
import Switch from "react-switch";

type Props = {
  fieldName: string;
  gstAccountIndex: number;
  formCompleteStatus: {
    [x: string]: UnderwritingFormStatus
  },
  newUploadedDocIds: number[],
  setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  deleteDocIds: number[],
  setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
  statementLength: number;
  gstApiErrors?: any;
  setGstApiErrors: React.Dispatch<React.SetStateAction<any>>;
  formContext?: any;
  formType: ApplicationContextType
}

const gstDocColumns = [
  {
    title: 'Type',
    key: 'type',
    alignment: alignmentType.leftAlign,
    width: '70%'
  },
  {
    title: "Attachment",
    key: "attachment",
    alignment: alignmentType.centerAlign,
    width: '30%'
  },
];

const gstProcessingStatus = new Set([GstAnalysisStatus.inProgress])

const GstAccount = ({ gstAccountIndex, fieldName, formCompleteStatus, newUploadedDocIds, setNewUploadedDocIds, deleteDocIds, setDeleteDocIds, statementLength, setGstApiErrors, gstApiErrors, formContext, formType }: Props) => {


  const { input: { value: gstinValue } } = useField(`${fieldName}.gstin`, { subscription: { value: true } })
  const { input: { value: gstUserName } } = useField(`${fieldName}.username`, { subscription: { value: true } });
  const { input: { value: statementJobId } } = useField(`${fieldName}.statementJobId`, { subscription: { value: true } });
  const { input: { value: isVerified } } = useField(`${fieldName}.isVerified`, { subscription: { value: true } });
  const { input: { value: isOld } } = useField(`${fieldName}.isOld`, { subscription: { value: true } });
  const { input: { value: isInActiveValue } } = useField(`${fieldName}.isInActive`, { subscription: { value: true } });


  const { extraFormDetails, gstAnalysisJobs, fetchGstAnalysisJobs } = useContext(formContext) as any;
  const [isJobProcessing, setIsJobProcessing] = useState(false);
  const [currentAnalysisJob, setCurrentAnalysisJob] = useState(null);

  const [isInActive, setIsInActive] = useState(false);
  const [inActiveReason, setInActiveReason] = useState('');
  const [isInActiveModalOpen, setIsInActiveModalOpen] = useState(false);


  useEffect(() => {
    // setIsInActive(isInActiveValue);
    if (isInActiveValue) {
      change(`${fieldName}.isInActive`, isInActiveValue);
    }
  }, [isInActiveValue]);

  // console.log('statementJobId', statementJobId);
  useEffect(() => {
    // console.log('statementAnalysisJobs', statementAnalysisJobs, 'statementJobId', statementJobId);
    const currentJob = getIn(gstAnalysisJobs, `${statementJobId}`);
    console.log('currentJob', currentJob);
    console.log('statementJobId', statementJobId);
    if (currentJob) {
      setCurrentAnalysisJob(currentJob);
      if (gstProcessingStatus.has(currentJob?.status)) {
        setIsJobProcessing(true);
      } else {
        setIsJobProcessing(false);
      }

      if (currentJob?.status == GstAnalysisStatus.success) {
        if (!isVerified) {
          change(`${fieldName}.isVerified`, true);
        }
      }
    } else {
      setIsJobProcessing(false);
    }
  }, [statementJobId, gstAnalysisJobs, isVerified]);

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [toBeRemovedIndex, setToBeRemovedIndex] = useState(null);
  const { mutators, change } = useForm();

  const handleSendOtp = async () => {
    try {
      const response: any = await RestS.generateGstOtp({
        gstin: gstinValue,
        username: gstUserName,
      })
      // console.log('response', response)
      // const response = { "success": false, "message": "Incorrect Input." }

      if (response?.success) {
        // open otp modal
        console.log('OTP sent successfully:', response);
        setIsOtpModalOpen(true);
      } else {
        setGstApiErrors({
          ...gstApiErrors,
          [`${fieldName}.gstin`]: response?.message,
          [`${fieldName}.username`]: response?.message,
        })
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  }

  const showAnalysisJobError = useMemo(() => {
    if (currentAnalysisJob?.status == GstAnalysisStatus.failure) {
      const errorDetails = currentAnalysisJob?.errorDetails;
      if (errorDetails) {
        return {
          title: 'GST Verification Failed',
          message: <>
            {currentAnalysisJob?.errorDetails?.errorMessage}
            <br />
            Contact Merito
          </>
        }
      } else {
        return {
          title: 'GST Verification Failed',
          message: <>Contact Merito</>
        }
      }
    }
  }, [currentAnalysisJob]);

  return (
    <>
      <div className={styles.fieldItemContainer} key={gstAccountIndex}>
        <div className={styles.headerContainer}>
          <div className={styles.leftContainer}>
            <div className={styles.title}>
              GSTIN {gstAccountIndex + 1}
            </div>
            {isVerified ? <div className={styles.verifiedIcon}>
              <CheckboxIcon />
            </div> : null}
          </div>
          <div className={styles.rightContainer}>
            {statementLength > 1 && !isOld ?
              <MeritoButton
                type='destructive-ghost'
                icon={<DeleteIcon />}
                onlyIcon={true}
                size='md2'
                onClick={() => {
                  setToBeRemovedIndex(gstAccountIndex);
                  setShowDeleteConfirmation(true);
                }}
              />
              : null}
          </div>
        </div>
        {showAnalysisJobError ? <div className={styles.errorRootContainer}>
          <div className={styles.topContainer}>
            <div className={styles.titleContainer}>
              <div className={styles.iconContainer}>
                <ErrorIcon />
              </div>
              <div className={styles.title}>
                {showAnalysisJobError?.title}
              </div>
            </div>
            <div className={styles.subTitle}>
              {showAnalysisJobError?.message}
            </div>
          </div>
        </div> : null}

        {isJobProcessing ?
          <div className={styles.loadingContainer}>
            <div className={styles.loadingProgress}>
              <CircularLoader />
            </div>
            <div className={styles.loadingText}>
              Verifying...
            </div>

          </div> : null}

        <div className={styles.fieldContainer}>
          <Field
            validate={(value) => {
              const errors = gstNumberValidation(value);
              if (errors == validationErrorTypes.invalid) {
                return 'Invalid GSTIN';
              } else if (errors == validationErrorTypes.required) {
                return 'Enter GSTIN';
              }
              return errors;
            }}
            name={`${fieldName}.gstin`}>
            {(props) => (
              <OutlinedFormInput
                {...props.input}
                disabled={isVerified || isOld || isJobProcessing}
                label='GSTIN'
                fieldType='lg'
                placeholder='22AAAAA9999A1Z5'
                name={props.input.name}
                value={props.input.value}
                onChange={(values) => {
                  props.input.onChange(values);
                  setGstApiErrors({
                    ...gstApiErrors,
                    [`${fieldName}.gstin`]: undefined,
                    [`${fieldName}.username`]: undefined,
                  })
                }}
                error={props.meta.error}
                touched={props.meta.touched}
                maxLength={15}
                allUpercase={true}
              />
            )}
          </Field>

          <Field
            validate={(value) => {
              if (!value) {
                return 'Enter username';
              }
              return ''
            }}
            name={`${fieldName}.username`}
          >
            {(props) => (
              <OutlinedFormInput
                {...props.input}
                disabled={isVerified || isOld || isJobProcessing}
                label='Username'
                fieldType='lg'
                placeholder='user1234@27gst'
                name={props.input.name}
                value={props.input.value}
                onChange={(values) => {
                  props.input.onChange(values);
                  setGstApiErrors({
                    ...gstApiErrors,
                    [`${fieldName}.gstin`]: undefined,
                    [`${fieldName}.username`]: undefined,
                  })
                }}
                error={props.meta.error}
                touched={props.meta.touched}
              />
            )}
          </Field>

          {
            !isOld ?
              <div className={styles.gstCertificateUploadContainer}>
                <div className={styles.label}>
                  Upload Documents
                </div>
                <TableForm
                  footerText={
                    <>Accepted file types: JPG, PNG and PDF.</>
                  }
                  headerColumns={gstDocColumns}
                  hideHeader={true}
                >

                  <TableUploadRow
                    isLast={true}
                    fieldName={`${fieldName}.gstCertificate`}
                    stepName={UnderwritingSteps.company}
                    documentType='companyDocuments'
                    fieldItem={{
                      title: 'GST Certificate',
                      subTitle: '',
                      key: `gstCertificate`,
                      isMultiFile: false,
                    }}
                    formCompleteStatus={formCompleteStatus}
                    deleteDocIds={deleteDocIds}
                    setDeleteDocIds={setDeleteDocIds}
                    newUploadedDocIds={newUploadedDocIds}
                    setNewUploadedDocIds={setNewUploadedDocIds}
                    formContext={formContext}
                    colWidths={gstDocColumns.map((item) => item.width)}
                  />
                </TableForm>
              </div> : null
          }

          {formType == ApplicationContextType.monthlyReport ?
            <div className={styles.gstSwitchRootContainer}>
              <div className={styles.leftContainer}>
                <div className={styles.title}>
                  GSTIN is active?
                </div>
                <div className={styles.subTitle}>
                  Turn off if not used for filings.
                </div>
              </div>
              <div className={styles.rightContainer}>
                <Field name={`${fieldName}.isInActive`}>
                  {(props) => {
                    return (
                      <Switch
                        draggable={false}
                        checked={!isInActive}
                        onChange={(checked) => {
                          // console.log('checked', checked)
                          // props.input.onChange(checked);
                          if (!checked) {
                            setIsInActive(true);
                            setInActiveReason('');
                            setIsInActiveModalOpen(true);
                          } else {
                            props.input.onChange(checked);
                          }
                        }}
                        onColor="#100828"
                        offColor="#D5D5D5"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                        height={24}
                        width={43}
                        className={styles.switch}
                        id="material-switch"
                      />
                    )
                  }}
                </Field>
              </div>
            </div>
            : null}

          <div className={styles.triggerOtpBtnContainer}>
            <Field
              name={`${fieldName}.isVerified`}>
              {({ meta }) => {
                return (
                  <div className={styles.errorText}>
                    {meta.error && meta.touched ? meta?.error : null}
                  </div>
                )
              }}
            </Field>
            {isJobProcessing || isVerified || isInActiveValue ? null : <MeritoButton
              type='primary-1'
              size='md2'
              btnText={"Send OTP"}
              onClick={() => {
                handleSendOtp();
              }}
              btnType='button'
              disabled={(gstinValue?.length != 15 || gstUserName?.length == 0) ? true : false}
            />}
          </div>
        </div>

        <GstOtpModal
          isOpen={isOtpModalOpen}
          handleModalClose={() => {
            setIsOtpModalOpen(false);
          }}
          onVerify={(values) => {
            // change(`${fieldName}.isVerified`, true)
            change(`${fieldName}.jobId`, values?.jobId);
            change(`${fieldName}.statementJobId`, values?.statementJobId);
            fetchGstAnalysisJobs();
            setIsOtpModalOpen(false);
          }}
          formDetails={{
            gstin: gstinValue,
            username: gstUserName,
            statementJobId: statementJobId,
            formType: extraFormDetails.formType,
            formId: extraFormDetails.id,
            monthYear: extraFormDetails.monthYear,
            fieldName: fieldName,
          }}
          onResendOtp={handleSendOtp}
        />
      </div>

      <ConfirmDialog
        modalStyles={{ maxWidth: '450px' }}
        showButton={false}
        visible={isInActiveModalOpen}
        toggle={() => {
          setIsInActive(false);
          setInActiveReason('');
          setIsInActiveModalOpen(!isInActiveModalOpen);
        }}
        showCloseBtn={false}
        size={"md"}
      >
        <div className={styles.confirmationContainer}>
          <div className={styles.topContainer}>
            <div className={styles.iconContainer}>
              <Exclamation />
            </div>
            <div className={styles.title}>
              Not using this GSTIN anymore?
            </div>
            <div className={styles.subTitle}>
              <div className={styles.gstinValue}>
                {gstinValue}
              </div>
            </div>
          </div>
          <div className={styles.fieldContainer}>
            <div className={styles.label}>
              Reason
            </div>
            <OutlinedFormInput
              fieldType='lg'
              placeholder='GST cancelled, wrong registration, not in use'
              name="inactiveReason"
              value={inActiveReason}
              onChange={(e) => {
                setInActiveReason(e.target.value);
              }}
              error={null}
              touched={false}
            />
          </div>

          <div className={styles.bottomContainer}>
            <MeritoButton onClick={() => {
              setIsInActive(false);
              setInActiveReason('');
              setIsInActiveModalOpen(false);
            }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Cancel'} />
            <MeritoButton size="lg" disabled={inActiveReason ? false : true} onClick={() => {
              if (!inActiveReason) return;
              change(`${fieldName}.isInActive`, true);
              change(`${fieldName}.inactiveReason`, inActiveReason);
              setIsInActiveModalOpen(false);
            }} isRounded={true} btnType="button" type="primary-1" btnText="Stop Using GSTIN" />
          </div>
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        modalStyles={{ maxWidth: '450px' }}
        showButton={false}
        visible={showDeleteConfirmation}
        toggle={() => {
          setShowDeleteConfirmation(!showDeleteConfirmation);
        }}
        showCloseBtn={false}
        size={"md"}
      >
        <div className={styles.confirmationContainer}>
          <div className={styles.topContainer}>
            <div className={styles.iconContainer}>
              <Exclamation />
            </div>
            <div className={styles.title}>
              Are You Sure You Want to Delete This GST Account?
              <br />
              <br />
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <MeritoButton onClick={() => {
              setShowDeleteConfirmation(false);
            }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Cancel'} />
            <MeritoButton size="lg" onClick={() => {
              mutators.remove('gstStatements', toBeRemovedIndex)
              setShowDeleteConfirmation(false);
            }} isRounded={true} btnType="button" type="primary-1" btnText="Delete" />
          </div>
        </div>
      </ConfirmDialog>
    </>
  );
}

export default GstAccount;